var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "print",
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.26 5.11H21.93V0.93C21.93 0.42 21.51 0 21 0H6.06C5.55 0 5.13 0.42 5.13 0.93V5.11H2.8C1.25 5.11 0 6.36 0 7.89V17.41C0 18.95 1.25 20.19 2.8 20.2H5.13V22.75C5.13 23.26 5.55 23.68 6.06 23.68H20.99H21C21.51 23.68 21.93 23.26 21.93 22.75V20.2H24.26H24.27C25.81 20.2 27.07 18.95 27.07 17.42V7.89C27.06 6.36 25.81 5.11 24.26 5.11ZM6.99 1.86H20.05V5.11H6.99V1.86ZM20.06 21.83H6.99V19.3C6.99 19.29 7 19.28 7 19.27C7 19.26 6.99 19.25 6.99 19.24V16.25H20.05V21.83H20.06ZM25.19 17.41C25.19 17.92 24.77 18.34 24.26 18.34H21.93V15.32C21.93 14.81 21.51 14.39 21 14.39H6.06C5.55 14.39 5.13 14.81 5.13 15.32V18.34H2.8C2.28 18.34 1.87 17.92 1.87 17.41V7.89C1.87 7.38 2.29 6.96 2.8 6.96H24.25C24.77 6.96 25.18 7.38 25.18 7.89V17.41H25.19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.d5d0ecba2626fde7ce49623456bacace.svg";
export { ForwardRef as ReactComponent };